import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UploaddataService {
  data: any
  constructor(private dataService: DataService, private http: HttpClient) { }


  getCustomerDocumentFileUploaderInstance(file) {
    return this.dataService.post('/api/ApplicationDocumentMapping/SaveApplicationDocuments', file)
  };

  debitFormDocumentUpload(document: any) {
    return this.dataService.post('/api/Report/debitFormBilling', document);
  };
  suspensionDocumentUpload(document: any) {
    return this.dataService.post('/api/ManageSuspension/SubmitSuspensionApprovalExcel', document)

  }

  SubmitSuspensionApprovalExcel(manageSuspensionId: number, formData: FormData) {
    return this.dataService.post(`/api/ManageSuspension/SubmitSuspensionApprovalExcel/${manageSuspensionId}`, formData);
  }
  UploadExcelOnly(document: any) {
    return this.dataService.post('/api/Report/UploadExcelOnly', document);
  }


  getCustomerDocumentList(customerApplicationId: number) {
    return this.dataService.getRecord('/api/ApplicationDocumentMapping/GetCustomerDocuments/' + customerApplicationId);
  };

  getUploadedDocuments(customerApplicationId: number) {
    return this.dataService.getRecord('/api/ApplicationDocumentMapping/getUploadedDocuments/' + customerApplicationId);
  };

  delteCustomerDocument(documentId: number) {
    return this.dataService.post('/api/ApplicationDocumentMapping/DeleteCustomerDocument/' + documentId, this.data);
  };

  downloadFile(documentId: number) {
    return this.dataService.getRecord('/api/ApplicationDocumentMapping/downloadfile/' + documentId);
  };

  downloadSCFile(documentId: number) {
    return this.dataService.getRecord('/api/ServiceChangeDocumentMapping/downloadfile/' + documentId);
  };

  getAllApplicationDocuments(applicationId: number) {
    return this.dataService.getRecord('/api/ApplicationDocumentMapping/getApplicationDocuments/' + applicationId);
  }

  getServiceChangeRequestDocuments(serviceChangeRequestId: number) {
    return this.dataService.getRecord('/api/ServiceChangeDocumentMapping/getApplicationDocuments/' + serviceChangeRequestId);
  }

  getDebitFormDocumentList(customerApplicationId: number) {
    return this.dataService.getRecord('/api/CustomerDocument/GetDebitFormDocument/' + customerApplicationId);
  };

  deleteDebitFormUpdateApplicationStatus(documentId: number, customerApplicationId) {
    return this.dataService.post('/api/CustomerDocument/DeleteDebitFormUpdateApplicationStatus/' + documentId + '/' + customerApplicationId, this.data);
  };

  getBankingDetailsUpdateFileUploaderInstance(data) {
    return this.dataService.post('/api/ApplicationDocumentMapping/SaveBankingDetailsUpdateProof', data);

  };
  downloadBankingDetailsProof(documentId: number) {
    return this.dataService.getRecord('/api/ServiceChangeDocumentMapping/GetBankingDetailsUpdateProof/' + documentId);
  };

  checkIdProofSave(applicationId: number) {
    return this.dataService.getRecord('/api/ApplicationDocumentMapping/checkIdProofSave/' + applicationId);
  };
}
